import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ReceiptPrintService {
  print(elementId = 'receipt-print'): void {
    const element = document.getElementById(elementId);
    if (!element) {
      window.print();
      return;
    }

    const html = `<!doctype html><html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1">
      <title>Receipt</title>
      <style>
        @page { size: 80mm auto; margin: 4mm; }
        html, body { margin: 0; padding: 0; }
        body { font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif; font-size: 13px; color: #000; background: #fff; }
        * { box-sizing: border-box; }
        .receipt-container { width: 72mm; max-width: 100%; margin: 0 auto; padding: 0; }
        .receipt-container * { margin: 0; padding: 0; }
        .receipt-container p, .receipt-container div, .receipt-container span { line-height: 1.3; }
        .receipt-container .receipt-print-content { font-family: ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif !important; }
        .receipt-container .text-center { text-align: center; }
        .receipt-container .flex { display: flex; justify-content: space-between; }
        .receipt-container .space-y-1 > * + * { margin-top: 0.25rem; }
        .receipt-container .space-y-2 > * + * { margin-top: 0.4rem; }
        .receipt-container .border-t { border-top: 1px dashed #000; }
        .receipt-container .border-b { border-bottom: 1px dashed #000; }
        .receipt-container .text-xs { font-size: 13px; }
        .receipt-container .text-sm { font-size: 14px; }
        .receipt-container .font-semibold { font-weight: 600; }
        .receipt-container .font-bold { font-weight: 700; }
        .receipt-container .tabular-nums { font-variant-numeric: tabular-nums; }
        .receipt-container .truncate { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
      </style>
    </head><body><div class="receipt-container">${element.innerHTML}</div></body></html>`;

    const iframe = document.createElement('iframe');
    Object.assign(iframe.style, {
      position: 'fixed',
      right: '0',
      bottom: '0',
      width: '1px',
      height: '1px',
      border: '0',
      visibility: 'hidden',
    });
    document.body.appendChild(iframe);
    const documentToPrint = iframe.contentWindow?.document;
    if (!documentToPrint) {
      iframe.remove();
      window.print();
      return;
    }

    documentToPrint.open();
    documentToPrint.write(html);
    documentToPrint.close();
    iframe.onload = () => {
      iframe.contentWindow?.focus();
      iframe.contentWindow?.print();
      setTimeout(() => iframe.remove(), 500);
    };
  }
}
